// 視窗寬度（警報工作台的版型斷點，SPEC #vms-web-alarm-workbench）。
import { useEffect, useState } from 'react';

export function useViewportWidth(): number {
  const [w, setW] = useState(() => (typeof window === 'undefined' ? 1280 : window.innerWidth));
  useEffect(() => {
    const on = () => setW(window.innerWidth);
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return w;
}
